import { type FC, type ReactNode } from "react";

import { clsx } from "clsx";

import { SectionLabel } from "@styled/section_label";

// A short list of files to pick from, with room for an add action below.
export const FileRail: FC<{
  label: string;
  footer: ReactNode;
  children: ReactNode;
}> = ({ label, footer, children }) => (
  <section className="surface-resting flex flex-col gap-1 rounded-[18px] p-4">
    <div className="px-2.5 pb-2">
      <SectionLabel size="xs">{label}</SectionLabel>
    </div>
    {children}
    <div className="mt-1 self-start">{footer}</div>
  </section>
);

export const FileRailItem: FC<{
  name: string;
  detail: string;
  active: boolean;
  onClick(): void;
}> = ({ name, detail, active, onClick }) => (
  <button
    type="button"
    aria-current={active || undefined}
    onClick={onClick}
    className={clsx(
      "rounded-xl px-2.5 py-[9px] text-left",
      active ? "surface-lit" : "hover:bg-quiet-hover",
    )}
  >
    <div
      className={clsx(
        "truncate text-[13px]",
        active ? "text-ink font-semibold" : "text-body font-medium",
      )}
    >
      {name}
    </div>
    <div className="text-[11.5px] text-slate-500">{detail}</div>
  </button>
);
